import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import TheCategoryManagerCreate from '@/components/v2/TheCategoryManagerCreate.vue';
import { CATEGORIES_ROUTE } from '@/helpers/constants/B2bRoutes';
let CategoryCreate = class CategoryCreate extends Vue {
    get categoriesRoute() {
        return CATEGORIES_ROUTE.name;
    }
};
CategoryCreate = __decorate([
    Component({
        components: {
            TheCategoryManagerCreate,
        },
    })
], CategoryCreate);
export default CategoryCreate;
